import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import TransaksiService from "../../services/transaksi/TransaksiService";
import { Button, Col, Form, OverlayTrigger, Row, Spinner, Tooltip } from "react-bootstrap";
import Card from "../../components/Card";
import DataTable from "react-data-table-component";
import { formatDateTimeLocalDate, getCurrentDateTimeFormattedOnly } from "../../utilities/Utils";
import { FaMinus, FaPaperPlane, FaPlus } from "react-icons/fa";
import ExpandableComponentSmkhpFinal from "./expand/ExpandableComponentSmkhpFinal";
import UploadService from "../../services/transaksi/UploadService";
import SweetAlert from "react-bootstrap-sweetalert";
import { generatePdfToBlob } from "../cetak/draft-pdf/GeneratePdfToBlob";
import { QRCodeCanvas } from "qrcode.react";

const DaftarSmkhpUsFinal = () => {
    const [qrImage, setQrImage] = useState(null)
    const qrImageCanvas = useRef()
    const qrText = "https://siapmutu.kkp.go.id/view-smkhp/" 

    const getQRCodeDataURL = (canvasRef) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                const canvas = canvasRef.current?.children[0]; // Get the canvas inside <QRCode />
                if (canvas) {
                    resolve(canvas.toDataURL("image/png")); // Convert to Base64
                } else {
                    resolve(null);
                }
            }, 500); // Delay to ensure QR code renders
        });
    };
    useEffect(() => {
        const generateQrCode = async () => {
            const dataUrl = await getQRCodeDataURL(qrImageCanvas)
            setQrImage(dataUrl)
        }
        generateQrCode()
    }, [])

    const columns = [
        {
            name: 'Nomor Aju',
            cell: row => row['nomorAju']
        },
        {
            name: 'Nomor SMKHP',
            cell: row => row['noHcMutu']
        },
        {
            name: 'Tanggal SMKHP',
            cell: row => formatDateTimeLocalDate(row['tglHcMutu'])
        },
        {
            name: 'NPWP',
            cell: row => row['npwpTrader']
        },
        {
            name: 'Nama Trader',
            cell: row => row['namaTrader']
        },
        {
            name: 'Action',
            cell: row => (
                <div className="row">
                    <div className="col-md-12 mb-3 mt-2">
                        <OverlayTrigger placement="bottom" overlay={
                            <Tooltip >Generate PDF Final</Tooltip>
                        }>
                            <Button size="sm" variant="primary" onClick={() => handleClickConfirmGenerate(row)}>
                                <FaPaperPlane />{' '} Buat File PDF Final
                            </Button>
                        </OverlayTrigger>
                    </div>
                </div>

            )
        }
    ]

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let uploadService = useMemo(() => new UploadService(), [])

    const [listData, setListData] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const [valueSearchNomorAju, setValueSearchNomorAju] = useState(null)
    const onChangeSearchNomorAju = e => {
        setValueSearchNomorAju(e.target.value)
    }

    const [valueSearchNoHcMutu, setValueSearchNoHcMutu] = useState(null)
    const onChangeSearchNoHcMutu = e => {
        setValueSearchNoHcMutu(e.target.value)
    }

    // const onClickReset = () => {
    //     setValueSearchNoHcMutu(null)
    //     setValueSearchNomorAju(null)
    //     getListSmkhp(0, 10)
    // }

    const getListSmkhp = useCallback(async (page, size) => {
        setLoading(true)
        try {
            let response
            if (localStorage.getItem("role") === "2" || localStorage.getItem("role") === "3" || localStorage.getItem("role") === "7") {
                response = await transaksiService.listSmkhpFinalUs(valueSearchNomorAju, valueSearchNoHcMutu, localStorage.getItem("kdUnit"), page, size)
            } else {
                response = await transaksiService.listSmkhpFinalUs(valueSearchNomorAju, valueSearchNoHcMutu, null, page, size)
            }
            setListData(response?.data?.data)
            setTotalData(response?.data?.totalData)
        } catch (error) {
            console.log(error)
            setListData([])
        }
        setLoading(false)
    }, [transaksiService, valueSearchNoHcMutu, valueSearchNomorAju])

    useEffect(() => {
        getListSmkhp(0, 10)
    }, [getListSmkhp])

    const handleChangePage = (page) => {
        getListSmkhp(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        let response
        if (localStorage.getItem("role") === "2" || localStorage.getItem("role") === "3" || localStorage.getItem("role") === "7") {
            response = await transaksiService.listSmkhpFinalUs(valueSearchNomorAju, valueSearchNoHcMutu, localStorage.getItem("kdUnit"), page, size)
        } else {
            response = await transaksiService.listSmkhpFinalUs(valueSearchNomorAju, valueSearchNoHcMutu, null, page, size)
        }
        setListData(response?.data?.data)
        setSize(size)
    }

    // const onClickCari = async () => {
    //     let response
    //     if (localStorage.getItem("role") === "2" || localStorage.getItem("role") === "3" || localStorage.getItem("role") === "7") {
    //         response = await transaksiService.listSmkhpFinalUs(valueSearchNomorAju, valueSearchNoHcMutu, localStorage.getItem("kdUnit"), 0, 10)
    //     } else {
    //         response = await transaksiService.listSmkhpFinalUs(valueSearchNomorAju, valueSearchNoHcMutu, null, 0, 10)
    //     }
    //     setListData(response?.data?.data)
    //     setTotalData(response?.data?.totalData)
    // }

    const [nomorAju, setNomorAju] = useState(null)
    const [noHcMutu, setNoHcMutu] = useState(null)

    const [showConfirmGenerate, setShowConfirmGenerate] = useState(false)
    const handleCloseConfirmGenerate = () => setShowConfirmGenerate(false)
    const handleClickConfirmGenerate = (row) => {
        setNomorAju(row?.nomorAju)
        setNoHcMutu(row?.noHcMutu)
        setShowConfirmGenerate(true)
    }

    const [loadingGenerate, setLoadingGenerate] = useState(false)
    const [generateSuccess, setGenerateSuccess] = useState(false)
    const [generateFailed, setGenerateFailed] = useState(false)

    const handleClickGenerate = async () => {
        setLoadingGenerate(true)
        try {
            const resDisposisiDraft = await transaksiService.listPenugasan(nomorAju, 9, 0, 10)
            let noTugas = resDisposisiDraft?.data?.data[0]?.noTugas
            let filename = 'SMKHP-' + noHcMutu + '-' + getCurrentDateTimeFormattedOnly() + '.pdf'

            const resPpm = await transaksiService.getPpmById(nomorAju)
            const datappm = resPpm?.data

            const pdfToBlob = await generatePdfToBlob({ datappm, noTugas, qrImage })
            const formData = new FormData()
            formData.append('file', pdfToBlob, filename)
            const resUpload = await uploadService.uploadFileFormData(nomorAju, formData)
            if (resUpload.status === 200) {
                let urlFile = process.env.REACT_APP_API_URL_FILE + '/view/' + nomorAju + '/' + filename
                let jsonHcFile = {
                    nomorAju: nomorAju,
                    noHcMutu: noHcMutu,
                    dokPath: urlFile,
                    dokName: filename,
                    createdBy: localStorage.getItem("userId"),
                    createdDate: new Date()
                }
                await transaksiService.saveSmkhpFile(jsonHcFile)
                setShowConfirmGenerate(false)
                setGenerateSuccess(true)
            } else {
                setShowConfirmGenerate(false)
                setGenerateFailed(true)
            }
        } catch (error) {
            setShowConfirmGenerate(false)
            setGenerateFailed(true)
        }
        setLoadingGenerate(false)
    }

    const handleClickGenerateSuccess = () => {
        setGenerateSuccess(false)
        getListSmkhp(0, 10)
    }

    const handleClickGenerateFailed = () => {
        setGenerateFailed(false)
    }

    return (
        <>
            <div ref={qrImageCanvas} style={{ display: "none" }}>
                <QRCodeCanvas value={qrText} size={100} />
            </div>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Pencarian Data</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-sm-4">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju</Form.Label>
                                            <Col sm="9">
                                                <Form.Control type="searchNib" placeholder="Nomor Aju" className="form-control-sm" value={valueSearchNomorAju} onChange={onChangeSearchNomorAju} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                                <div className="col-sm-4">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor SMKHP</Form.Label>
                                            <Col sm="7">
                                                <Form.Control type="searchNib" placeholder="Nomor SMKHP" className="form-control-sm" value={valueSearchNoHcMutu} onChange={onChangeSearchNoHcMutu} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                            {/* <div className="row">
                                <div className="col-sm-12">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Col sm="2">
                                                <Button type="button" variant="btn btn-primary" size="sm" onClick={() => onClickCari()}>Cari</Button>{' '}
                                                <Button type="button" variant="btn btn-danger" size="sm" onClick={() => onClickReset()}>Reset</Button>{' '}
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div> */}
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar SMKHP FINAL Tujuan Amerika Serikat</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listData}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    persistTableHead={true}
                                    expandableRows
                                    expandOnRowDoubleClicked
                                    expandableIcon={{
                                        collapsed: <FaPlus size={12} color="blue" />, // Custom expand icon
                                        expanded: <FaMinus size={12} color="red" />,   // Custom collapse icon
                                    }}
                                    expandableRowsComponent={({ data }) => <ExpandableComponentSmkhpFinal data={data} />}

                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            {
                showConfirmGenerate &&
                <SweetAlert
                    title="Buat File SMKHP Final?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingGenerate ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Generate...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickGenerate}
                    onCancel={handleCloseConfirmGenerate}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingGenerate}
                >
                    {loadingGenerate && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Generate data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                generateSuccess &&
                <SweetAlert
                    title="SMKHP Final Berhasil Dibuat"
                    success
                    onConfirm={handleClickGenerateSuccess}
                    btnSize="sm"
                />
            }
            {
                generateFailed &&
                <SweetAlert
                    title="SMKHP Final Gagal Dibuat"
                    danger
                    onConfirm={handleClickGenerateFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default DaftarSmkhpUsFinal